import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isUserHasAccess } from 'helpers/permissions';

import { User } from 'entities/Account';

import { PopupsActions } from 'store/reducers/popups';

interface CheckAccessHocProps {
  creatorId: number;
  creatorUserName: string;
  creator?: User | null;
  children: React.ReactElement;
  openModal?: boolean;
  isExclusive: boolean;
  isSecondary: boolean;
}

const CheckAccessHoc: React.FC<CheckAccessHocProps | any> = (props: CheckAccessHocProps) => {
  const dispatch = useDispatch();

  // Selectors
  const {
    subscribing: { list },
    account: {
      account,
      role,
      loading: { account: accountLoading },
    },
  } = useSelector((state) => state);

  // Props
  const { children, creatorId, creatorUserName, openModal, isExclusive, isSecondary, creator } = props;

  // Constants
  const rights = list ?? [];
  const isCelebrity = role === 'celebrity';

  const [hasAccess, setHasAccess] = useState<boolean>(false);

  const openAccess = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    if (!hasAccess && isExclusive) {
      dispatch(PopupsActions.notEnoughRights(true));
      dispatch(PopupsActions.toggleNoRightsModal(true));
      dispatch(PopupsActions.setCurrentTokenCreatorId(creatorId));
      creator && dispatch(PopupsActions.setCreator(creator));
    }
  };

  useEffect(() => {
    if (accountLoading || !account) {
      return;
    }
    setHasAccess(isUserHasAccess(rights, creatorUserName) || account?.nickName === creatorUserName || isCelebrity || isSecondary);
  }, [list, account, accountLoading]);

  useEffect(() => {
    if (accountLoading || !account) {
      return;
    }
    if (openModal && hasAccess) {
      dispatch(PopupsActions.notEnoughRights(false));
      dispatch(PopupsActions.setCurrentTokenCreatorId(creatorId));
      creator && dispatch(PopupsActions.setCreator(creator));
    }
  }, [openModal, hasAccess, accountLoading, account]);

  return hasAccess ? (
    children
  ) : (
    <>
      {React.cloneElement(children, {
        onClick: openAccess,
        subscribe: hasAccess,
      })}
    </>
  );
};

export default CheckAccessHoc;
